export default "__VITE_ASSET__BwLEVavB__"